import { useOverlayStepsOrchestrator } from "./useOverlayStepsOrchestrator";

const KEY = "app-overlay";

export const useOverlayTrigger = () => {
  const canDisplay = useOverlayStepsOrchestrator(KEY);

  return { canDisplay };
};
